import React from "react";
import "./Multimedia_Why_Choose_Us.css";

function Multimedia_Why_Choose_Us({text1, text2}) {
  return (
    <>
      <section className="Multimedia_Why_Choose_Us Who_Should_Use_This">
        <div className="container">
          <div className="row">
            <div className="col-xl-5 col-lg-4 col-md-3 col-sm-4">
              <div className="heading_holder">
                <h3>
                  Why <br /> Choose Us?
                </h3>
              </div>
            </div>

            <div className="col-xl-7 col-lg-8 col-md-9 col-sm-8">
              <div className="content_holder">
                <h3>At ReachOut Media Tech Pvt. Ltd. </h3>

                <p>
                 {text1}
                </p>
                {/* <br />
                <p>
                  <b>CTA: </b> <br />{text2}
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Multimedia_Why_Choose_Us;
